import { Output, EventEmitter } from '@angular/core';

export abstract class ModalComponent<T> {

  @Output()
  public onClose: EventEmitter<T> = new EventEmitter();

  @Output()
  public onDismiss: EventEmitter<any> = new EventEmitter();

  public setOptions(options: any) { }

  public close(data?: any): void {
    this.onClose.emit(data);
  }

  public dismiss(): void {
    this.onDismiss.emit(null);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/notify/modal-component.ts